import http from '@core/fetch'

export default {
  canUpgrade: () => http('/p/wedding/index.php/Admin/APIMerchant/upgrade'),
  upgradeApi: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/upgrade_apply', { body }), //升级
  get_status: () =>
    http('/p/wedding/index.php/Admin/APIMerchant/upgrade_status'), // 获取状态,判断是否升级
  //添加/编辑
  edit: params =>
    http.post(`/p/wedding/index.php/Admin/APIMerchant/upgrade_apply`, {
      body: params
    }),
  // 获取数据
  get_data: () => http(`/p/wedding/index.php/Admin/APIMerchant/upgrade_apply`)
}
